import React, { createContext, useContext, ReactNode } from 'react';
import { useGeolocalizacionSilenciosa } from '../components/entregas/hooks/useGeolocalizacionSilenciosa';

// ============================================================================
// TIPOS
// ============================================================================

interface GeolocationContextType {
  ubicacionActual: { lat: number; lng: number } | null;
  errorUbicacion: string | null;
  startLocationTracking: () => Promise<void>;
  stopLocationTracking: () => void;
  isTracking: boolean;
}

// ============================================================================
// CONTEXTO
// ============================================================================

const GeolocationContext = createContext<GeolocationContextType | undefined>(undefined);

// ============================================================================
// PROVIDER
// ============================================================================

interface GeolocationProviderProps {
  children: ReactNode;
}

export const GeolocationProvider: React.FC<GeolocationProviderProps> = ({ children }) => {
  const geolocationData = useGeolocalizacionSilenciosa();

  return (
    <GeolocationContext.Provider value={geolocationData}>
      {children}
    </GeolocationContext.Provider>
  );
};

// ============================================================================
// HOOK
// ============================================================================

export const useGeolocationContext = (): GeolocationContextType => {
  const context = useContext(GeolocationContext);
  if (context === undefined) {
    throw new Error('useGeolocationContext must be used within a GeolocationProvider');
  }
  return context;
};

export default GeolocationContext;
